import { RouterView } from "vue-router";
import { teamRouting } from "./labor-team/team.routing";
import { laboreTamRouting } from "./laborteam-members/team.routing";
import { WorkerRosterRouting } from "./Worker-Roster-Management/team.routing";
import { QuantitiesRouting } from "./quantities/quantities.routing";
import {workersQuantityRouting} from "./workers-quantity/workers-quantity.routing";
import {laborSettlementRouting} from "./labor-settlement/labor-settlement.routing";
import GroupAttendanceRouting from "@/views/labor/group-attendance/group.attendance.routing";
import MonthlySalaryRouting from "@/views/labor/monthly-salary/monthly.salary.routing";
import AttendanceStatisticsRouting from "@/views/labor/attendance-statistics/attendance.statistics.routing";
import { participantsRouter } from "./participants/participants.routing";

export const LaborRouting = {
  path: "/labor",
  name: "labor",
  redirect: "/labor/quantities/list",
  component: RouterView,
  meta: { title: "劳务管理", icon: "laowu" },
  children: [
    ...teamRouting,
    ...laboreTamRouting,
    ...WorkerRosterRouting,
    ...QuantitiesRouting,
    ...AttendanceStatisticsRouting,
    ...MonthlySalaryRouting,
    ...GroupAttendanceRouting,
    ...workersQuantityRouting,
    ...laborSettlementRouting,
    ...participantsRouter,
  ],
};
